import { Stack } from '@mui/joy';
import { styled } from '@mui/joy';

export const StyledActFormTitleContainer = styled(Stack)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  flexDirection: 'row',
  gap: theme.spacing(1),
}));
